import { Directive, input } from '@angular/core';

@Directive({
  selector: '[dojoStemLabelIndex]',
  standalone: true,
})
export class StemLabelIndexDirective {
  readonly index = input.required<number>({ alias: 'dojoStemLabelIndex' });
}
